import styles from './index.module.scss';
import TextInput from "@/app/_components/Shared/TextInput";
import MailGray from "@/app/icons/mail-gray.svg";
import UserIcon from "@/app/icons/user.svg";

export default function PersonalDetails({data, onChange}) {
    return (
        <div className={styles.container}>
            <h2>Enter Your Details</h2>
            <TextInput placeholder="Your Name" required icon={UserIcon} value={data.full_name} onChange={(e) => onChange('full_name', e.target.value)}/>
            <TextInput placeholder="Company Name" required value={data.business_name} onChange={(e) => onChange('business_name', e.target.value)}/>
            <TextInput type="email" placeholder="Email" required icon={MailGray} value={data.email} onChange={(e) => onChange('email', e.target.value)}/>
            <TextInput type="phone" placeholder="Phone" rules={{ required: true }} value={data.phone} onChange={(value) => onChange('phone', value)}/>
        </div>
    )
}